import { CacheKeys } from 'app/shared/models/energy/cache-keys.model';

class LocalStorageService {
  public setRegion(location: string) {
    if (location !== 'ACT' && location !== 'NT' && location !== 'TAS') {
      localStorage.setItem(CacheKeys.region, location);
    }
  }
}

export const localStorageService = new LocalStorageService();
